import React from 'react'
import { BiFilterAlt } from 'react-icons/bi'

const DashboardFilterCard = ({ title, dropDownTitle, selectOptionTitle, selectedValue, handleChange, dataList, fromDate, setFromDate, toDate, setToDate, handleFilter, handleDateFilter }) => {

    return (
        <div className='w-full bg-white shadow-lg rounded-lg flex flex-col p-4'>
            <div className='text-3xl font-bold text-text_1 mb-2'>{title}</div>
            <div className='text-text_2 text-xl mb-8'>All dashboard</div>
            <div className='flex flex-col xl:flex-row gap-4'>
                <div className='w-full xl:w-[35%] flex flex-col sm:flex-row gap-4 items-end'>
                    <div className='w-full'>
                        <div className='text-text_1 text-lg font-bold mb-2'>{dropDownTitle}</div>
                        <select id="branch" value={selectedValue} onChange={handleChange} className='w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary'>
                            <option value="">{selectOptionTitle}</option>
                            {dataList?.map((data, index) => {
                                return (
                                    <option key={index} value={data?.id}>{data?.name}</option>
                                )
                            })}

                        </select>
                    </div>
                </div>
                <div className='w-full xl:w-[65%] flex flex-col lg:flex-row items-end gap-4'>
                    <div className='w-full'>
                        <div className='text-text_1 text-lg font-bold mb-2'>From Date</div>
                        <input type="date" id="start" name="trip-start" value={fromDate} onChange={e => setFromDate(e.target.value)} className='w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none' />
                    </div>
                    <div className='w-full'>
                        <div className='text-text_1 text-lg font-bold mb-2'>To Date</div>
                        <input type="date" id="start" name="trip-start" value={toDate} onChange={e => setToDate(e.target.value)} className='w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none' />
                    </div>
                    <div onClick={() => {
                        setFromDate('');
                        setToDate('');
                    }} className='py-2 px-3 border border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:text-white'>
                        <BiFilterAlt />
                        Reset
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardFilterCard